import React, { Component } from 'react';

export class Estado extends Component {
    static displayName = Estado.name;

    componentDidMount() {
        function getParameterByName(name) {
            name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
            var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
                results = regex.exec(window.location.search);
            return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        };

        var id = getParameterByName('idtransaccion');
        this.validateRedirect(id);
    }

    render() {
        return (
            <div>
            </div>
        );
    }

    async validateRedirect(id) {
        const response = await fetch('/Estado?idTransaccion=' + id);
        const data = await response.json();
        console.log(data)
        window.location.href = data.url;
    }
}